import React, { useState } from 'react';
import { MapPin, Plus, Trash2, Loader2 } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { ordersAPI } from '../services/api';

const TYPE_LABELS = { processing: 'Préparation en cours', shipped: 'Expédié', delivered: 'Livré', handed_over: 'Colis remis au transporteur' };
const fmt = (d) => new Date(d).toLocaleString('fr-FR', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });

const TrackingEventsPanel = ({ order, onUpdated }) => {
  const [label, setLabel] = useState('');
  const [location, setLocation] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const events = order.tracking_events || [];

  const add = async () => {
    setError('');
    if (label.trim().length < 2) { setError('Décrivez l\'étape (2 caractères minimum)'); return; }
    setBusy(true);
    try {
      const r = await ordersAPI.addTrackingEvent(order.id, { label: label.trim(), location: location.trim() });
      onUpdated({ ...order, tracking_events: r.events });
      setLabel(''); setLocation('');
    } catch (e) {
      setError(e.response?.data?.detail || 'Impossible d\'ajouter l\'étape');
    } finally { setBusy(false); }
  };

  const remove = async (id) => {
    setBusy(true);
    try {
      await ordersAPI.deleteTrackingEvent(order.id, id);
      onUpdated({ ...order, tracking_events: events.filter((e) => e.id !== id) });
    } finally { setBusy(false); }
  };

  return (
    <div className="border border-gray-200 rounded-lg p-4" data-testid="tracking-events-panel">
      <h3 className="font-semibold text-gray-900 flex items-center gap-2 mb-1"><MapPin size={18} className="text-orange-500" /> Étapes de livraison visibles par le client</h3>
      <p className="text-xs text-gray-500 mb-3">Les changements de statut et le n° de suivi créent des étapes automatiquement. Ajoutez ici des précisions (ex. « Colis en transit », Lyon).</p>
      {events.length > 0 && (
        <ul className="space-y-1.5 mb-3" data-testid="tracking-events-list">
          {events.map((e) => (
            <li key={e.id} className="flex items-center justify-between gap-2 text-sm bg-gray-50 rounded-md px-3 py-1.5" data-testid="tracking-event-row">
              <span><span className="font-medium">{e.type === 'custom' ? e.label : TYPE_LABELS[e.type] || e.type}</span>{e.location ? ` · ${e.location}` : ''} <span className="text-gray-400 text-xs">— {fmt(e.at)}{e.author === 'admin' ? ' · admin' : ''}</span></span>
              <button type="button" onClick={() => remove(e.id)} disabled={busy} className="text-gray-400 hover:text-red-600" data-testid={`tracking-event-delete-${e.id}`} title="Supprimer"><Trash2 size={14} /></button>
            </li>
          ))}
        </ul>
      )}
      {error && <p className="text-xs text-red-600 mb-2" data-testid="tracking-event-error">{error}</p>}
      <div className="grid grid-cols-1 sm:grid-cols-[1fr_160px_auto] gap-2">
        <Input data-testid="tracking-event-label" value={label} onChange={(e) => setLabel(e.target.value)} placeholder="Étape (ex : Colis en transit)" className="h-9 text-sm" />
        <Input data-testid="tracking-event-location" value={location} onChange={(e) => setLocation(e.target.value)} placeholder="Lieu (optionnel)" className="h-9 text-sm" />
        <Button data-testid="tracking-event-add" size="sm" onClick={add} disabled={busy} className="bg-[#1e3a5f] hover:bg-[#2d4a6f]">{busy ? <Loader2 size={14} className="animate-spin" /> : <Plus size={14} />}</Button>
      </div>
    </div>
  );
};

export default TrackingEventsPanel;
